module.exports = __webpack_public_path__ + "img/doctor-bg.238515ae.jpg";